import React, { Component } from 'react';

import Highlighter from 'react-highlight-words';
import TextCropper from '@omilia/text-cropper';

import {
  SNameContainer,
  SHeader,
  SItem,
  SNonHighlightableNamePart,
  SSecondaryInfoText,
  SHeaderTitle,
} from './styled';

type Url = string;

type Item = {
  header: string;
  id: string;
  name: string;
  nameIsHighlightable: boolean;
  secondaryInfoText: string;
  icon: string;
  count: string;
  xpack?: string;
  subUrl: Url;
};

interface Props {
  item: Item;
  value: string;
  onSelect: (subUrl: Url) => void;
}

class SearchResultItem extends Component<Props> {
  getNameHighlight = ({
    name,
    nameIsHighlightable,
  }: Pick<Item, 'name' | 'nameIsHighlightable'>) => {
    let highlightableNamePart = '';
    let unhighlightableNamePart = '';

    if (nameIsHighlightable) {
      const nameSpittedByDot = name.split('.');
      if (nameSpittedByDot.length === 1) {
        [highlightableNamePart] = nameSpittedByDot;
      } else {
        [unhighlightableNamePart, highlightableNamePart] = nameSpittedByDot;
      }
      return { highlightableNamePart, unhighlightableNamePart };
    }

    unhighlightableNamePart = name;
    return { unhighlightableNamePart, highlightableNamePart };
  };

  handleSelect = () => {
    const {
      item: { subUrl },
      onSelect,
    } = this.props;

    onSelect(subUrl);
  };

  renderNameUnhighlightablePart = (
    unhighlightableNamePart: string,
    highlightableNamePart: string,
  ) =>
    unhighlightableNamePart.length > 0 && (
      <SNonHighlightableNamePart>
        {`${unhighlightableNamePart}${
          highlightableNamePart.length > 0 ? '.' : ''
        }`}
      </SNonHighlightableNamePart>
    );

  renderNameHighlightablePart = (highlightableNamePart: string) =>
    highlightableNamePart.length > 0 && (
      <Highlighter
        autoEscape
        highlightStyle={{
          backgroundColor: 'unset',
          fontWeight: 'bold',
          color: '#475369',
        }}
        searchWords={[this.props.value]}
        textToHighlight={highlightableNamePart}
      />
    );

  render() {
    const { item } = this.props;

    if (item.header) {
      return (
        <SHeader data-test="item-header">
          <i className={`icon icon-${item.icon}`} />

          <SHeaderTitle data-test="header-title">{item.header}</SHeaderTitle>
          <span>{item.count}</span>
        </SHeader>
      );
    }

    const {
      highlightableNamePart,
      unhighlightableNamePart,
    } = this.getNameHighlight(item);

    return (
      <SItem onClick={this.handleSelect}>
        <SNameContainer>
          <TextCropper placement="right" text={item.name}>
            {this.renderNameUnhighlightablePart(
              unhighlightableNamePart,
              highlightableNamePart,
            )}
            {this.renderNameHighlightablePart(highlightableNamePart)}
          </TextCropper>
          {item.xpack && <sup>XP</sup>}
        </SNameContainer>

        {!!item.secondaryInfoText && (
          <SSecondaryInfoText data-test="secondary-info-text">
            {item.secondaryInfoText}
          </SSecondaryInfoText>
        )}
      </SItem>
    );
  }
}

export default SearchResultItem;
